import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { doc } from 'firebase/firestore';
import { auth, db } from '../FirebaseConfig'; 
import { Link } from 'react-router-dom'; 

const UnverifiedAlert = () => {
  const [user, loading] = useAuthState(auth);
  const [profile, profileLoading] = useDocumentData(user && doc(db, 'profiles', user.uid));

  // Determine if the user is a seller and their account is unverified
  const isUnverifiedSeller = user && profile?.role === 'seller' && profile?.verification_status !== 'approved';

  // Don't render anything if the user is not a seller, is a verified seller,
  // or if the data is still loading.
  if (loading || profileLoading || !isUnverifiedSeller) {
    return null;
  }

  return (
    <div className="absolute top-[79px] left-0 right-0 z-50 bg-yellow-400 text-yellow-900 p-3 text-center shadow-md">
      <p className="font-semibold text-sm md:text-base">
        ⚠️ Your account is unverified. Please{' '}
        <Link to="/verify" className="underline font-bold hover:text-yellow-700">
          complete your verification
        </Link>{' '}
        to gain customer trust and unlock all features.
      </p>
    </div>
  );
};

export default UnverifiedAlert;